import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClassBookingConfig } from '../../model/class-booking-config';
import { BaseDirective } from '@egym/ngx-adm-int';

@Component({
  selector: 'gymfinder-access-config',
  templateUrl: './access-config.component.html',
  styleUrls: ['./access-config.component.scss'],
  standalone: false,
})
export class AccessConfigComponent extends BaseDirective<void> {
  @Input() classBookingConfig: ClassBookingConfig;
  @Input() geofence?: number | null;
  @Input() gymUUID?: string;
  @Input() tanAccountCreationEnabled = false;

  @Output() accessConfigChanged = new EventEmitter<{
    classBookingConfig: ClassBookingConfig;
    geofence?: number | null;
    tanAccountCreationEnabled: boolean;
  }>();

  constructor(snackBar: MatSnackBar) {
    super(snackBar);
  }

  onSave(): void {
    if (this.gymUUID && (this.geofence == null || this.geofence <= 0)) {
      this.openSnackBar('Geofence must be greater than 0');
      return;
    }
    if (
      this.gymUUID &&
      this.classBookingConfig.checkinOnlyGym &&
      this.classBookingConfig.bookingRequiredForCheckin
    ) {
      this.openSnackBar(
        'You can’t have a gym with only booking and only check-in at the same time. Please choose to keep only one of these options: “In-app booking required for every check-in” or “Check-in only gym”.'
      );
      return;
    }
    this.accessConfigChanged.emit({
      classBookingConfig: this.classBookingConfig,
      geofence: this.geofence,
      tanAccountCreationEnabled: this.tanAccountCreationEnabled,
    });
  }
}
